import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { TraaqrTag } from '../../models/traaqrTag';
import { Observable } from 'rxjs';

export class TraaqrTagDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.TRAAQRTAG, apiHelper);
  }

  public loadByToken(token: any): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + `/public/by-token?token=${token}`;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }
}
